import { Link } from "react-router-dom";
import { Heart, Fuel, Gauge, Calendar, MapPin } from "lucide-react";
import { imgUrl, euro, km } from "@/lib/api";
import { useUser } from "@/context/UserContext";
import { SellerBadge, ModeBadge } from "@/components/SellerBadge";

export const ListingCard = ({ listing, index = 0 }) => {
  const { favIds, toggleFavorite } = useUser();
  const fav = favIds.includes(listing.id);
  return (
    <article
      data-testid={`listing-card-${listing.id}`}
      className="group bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-sm hover:shadow-lg hover:-translate-y-0.5 transition-[box-shadow,transform] duration-300 fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <Link to={`/veicolo/${listing.id}`} className="block relative aspect-[4/3] overflow-hidden bg-slate-100" data-testid={`listing-card-link-${listing.id}`}>
        <img src={imgUrl(listing.images?.[0])} alt={`${listing.brand} ${listing.model}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
        <div className="absolute top-3 left-3"><SellerBadge type={listing.seller_type} /></div>
        {listing.status === "sold" && (
          <div className="absolute inset-0 bg-slate-900/60 grid place-items-center text-white font-heading text-2xl font-bold">VENDUTO</div>
        )}
      </Link>
      <div className="p-5">
        <div className="flex items-start justify-between gap-3">
          <Link to={`/veicolo/${listing.id}`} className="min-w-0">
            <p className="text-xs font-medium text-slate-500 uppercase tracking-wider">{listing.brand}</p>
            <h3 className="font-heading text-lg font-semibold text-slate-900 truncate">{listing.model}</h3>
          </Link>
          <button
            data-testid={`listing-favorite-button-${listing.id}`}
            onClick={() => toggleFavorite(listing.id)}
            className={`shrink-0 w-9 h-9 grid place-items-center rounded-full border transition-colors duration-200 ${fav ? "bg-rose-50 border-rose-200 text-rose-600" : "border-slate-200 text-slate-400 hover:text-rose-500"}`}
            aria-label="Preferito"
          >
            <Heart size={16} fill={fav ? "currentColor" : "none"} />
          </button>
        </div>
        <div className="mt-3 grid grid-cols-3 gap-2 text-xs text-slate-600 whitespace-nowrap">
          <span className="flex items-center gap-1"><Calendar size={13} />{listing.year}</span>
          <span className="flex items-center gap-1"><Gauge size={13} />{km(listing.km)}</span>
          <span className="flex items-center gap-1"><Fuel size={13} />{listing.fuel}</span>
        </div>
        <div className="mt-4 pt-4 border-t border-slate-100 flex items-end justify-between">
          <div>
            <p className="font-mono text-xl font-medium text-slate-900" data-testid={`listing-card-price-${listing.id}`}>{euro(listing.price)}</p>
            <p className="text-xs text-slate-500 flex items-center gap-1 mt-0.5"><MapPin size={12} />{listing.city}</p>
          </div>
          <ModeBadge offers={listing.accept_offers} />
        </div>
      </div>
    </article>
  );
};
